import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'

export default function TableShimmer(){
    return(
        Array.from({ length: 5 }, (_, index) => 
            <div key={index} className="border border-[#DEDEDE] table-row  h-14 ">
                <td className=" pl-12 pr-4 py-4 text-[16px] leading-normal font-medium">
                    <SkeletonTheme baseColor="#f0f0f0" highlightColor="#e0e0e0">
                        <Skeleton count={1} className='h-[30px] max-w-[200px]' />
                    </SkeletonTheme>
                </td>
                <td className=" px-4 py-4 w-[90px] h-[70px]">
                    <SkeletonTheme baseColor="#f0f0f0" highlightColor="#e0e0e0">
                        <Skeleton count={1} className='h-[30px] max-w-[300px]' />
                    </SkeletonTheme>
                </td>
                <td className="px-4 py-3 text-[16px] w-[90px] text-center leading-normal">
                    <SkeletonTheme baseColor="#f0f0f0" highlightColor="#e0e0e0">
                        <Skeleton count={1} className='h-[30px] max-w-[180px]' />
                    </SkeletonTheme>
                </td>
                <td className="px-4 py-3 text-[16px] text-center leading-normal">
                    <SkeletonTheme baseColor="#f0f0f0" highlightColor="#e0e0e0">
                        <Skeleton count={1} className='h-[30px] max-w-[120px]' />
                    </SkeletonTheme>
                </td>
                <td className=" pl-4 pr-0 py-3 text-[16px] text-center leading-normal rounded-[10px]">
                    <SkeletonTheme baseColor="#f0f0f0" highlightColor="#e0e0e0">
                        <Skeleton count={1} className='h-[30px] max-w-[120px]' />
                    </SkeletonTheme>
                </td>
            </div>)
    )
}